export const CodeMinifierInfos = ['json', 'html', 'js', 'css']
  .map(lang => ({
    key: `${lang}-minifier`,
    category: 'minify',
    group: lang,
    url: `/${lang}-minifier`,
    isPrivate: false,
  }))

